export default __webpack_public_path__ + "static/media/icon-lock.114afc01.svg";